module.exports = __webpack_public_path__ + "media/email.7e359f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email.png
// module id = 369
// module chunks = 0